import { Input } from 'antd-mobile'
import { SchemaType } from '../index.d';

// 物料组件接入口啊 快把你的组件接入进来 让我们一起嗨起来
const renderers: Record<SchemaType | string, any> = {
  'input-text': Input,
}

export default renderers;
